import {
  FileAddOutlined,
  SaveOutlined,
  SelectOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Collapse,
  Row,
  Space,
  Spin,
  Tabs,
  Typography,
  message
} from 'antd';
import lodashClonedeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import MonedaSelector from '../../components/MonedaSelector';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import PlanSelector from '../../forms/personal/PlanSelector';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import PlanEditor from './PlanEditor';

const { TabPane } = Tabs;
const { Panel } = Collapse;

function PanelHeader(props) {
  const { empresa } = props;

  return (
    <table justify="start" align="middle">
      <tbody>
        <tr>
          <td
            style={{
              verticalAlign: 'top',
              width: '48px',
              objectFit: 'contain'
            }}
          >
            <img
              src={`/images/empresas/${empresa.codigo}.png`}
              alt="imagen empresa"
              width="100%"
              style={{
                verticalAlign: 'top',
                maxHeight: '48px',
                maxWidth: '48px',
                objectFit: 'contain'
              }}
            />
          </td>
          <td
            style={{
              textAlign: 'left',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              paddingLeft: 20,
              paddingRight: 20
            }}
          >
            {empresa.nombre}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

const groupBy = (list, keyGetter, dataGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, {
        data: dataGetter ? dataGetter(item) : item,
        list: [item]
      });
    } else {
      collection.list.push(item);
    }
  });
  return map;
};

const AdminAseguradoraLanding = () => {
  const [loading, setLoading] = useState(false);
  const [asignados, setAsignados] = useState();
  const [activeTab, setActiveTab] = useState({});
  const [mostrarSelector, setMostrarSelector] = useState({
    empresa: null,
    producto: null,
    estado: false
  });
  const [empresaCoberturaItems, setEmpresaCoberturasItems] = useState([]); // Solo incluye los registros modificados y agregados
  const [
    empresaCoberturaItemsEliminadas,
    setEmpresaCoberturasItemsEliminadas
  ] = useState([]);
  const [selectedPlanEstandarIndex, setSelectedPlanEstandarIndex] = useState(
    -1
  );
  const [
    selectedPlanEspecificoIndex,
    setSelectedPlanEspecificoIndex
  ] = useState(-1);
  const [selectedPlan, setSelectedPlan] = useState();
  const [monedas, setMonedas] = useState();
  const [monedaProductoList, setMonedaProductoList] = useState([]);

  const {
    params: { id: idAseguradora }
  } = useRouteMatch();
  const history = useHistory();

  const configurarPlanes = async () => {
    history.push(`/admin-aseguradora-planes/${idAseguradora}`);
  };

  const onClickPlanes = async ({ empresaId, productoId }) => {
    setSelectedPlanEstandarIndex(-1);
    setSelectedPlanEspecificoIndex(-1);

    if (
      mostrarSelector.empresa === empresaId &&
      mostrarSelector.producto === productoId
    ) {
      setMostrarSelector({
        ...mostrarSelector,
        estado: !mostrarSelector.estado
      });
    } else {
      setMostrarSelector({
        empresa: empresaId,
        producto: productoId,
        estado: true
      });
    }
  };

  const onChangeMoneda = (value, item) => {
    const selected = monedas.filter((moneda) => moneda.codigo === value)[0];

    monedaProductoList.map((monedaProducto, index) => {
      if (
        monedaProducto.idProducto === item.producto.id &&
        monedaProducto.idEmpresa === item.aseguradoraEmpresa.id_empresa
      ) {
        // Si el producto ya existe en el listado, entonces se elimina y adelante se vuelve agregar con la nueva moneda seleccionada
        monedaProductoList.splice(index, 1);
      }
      return monedaProducto;
    });

    // En el state se agregan los productos cuya moneda se haya seleccionado/modificado
    setMonedaProductoList([
      ...monedaProductoList,
      {
        idEmpresa: item.aseguradoraEmpresa.id_empresa,
        idProducto: item.producto.id,
        moneda: selected
      }
    ]);
  };

  const onChangeActiveTab = (indexCorredora, index, tab) => {
    setActiveTab({
      ...activeTab,
      [indexCorredora]: { [index]: tab }
    });
  };

  const ButtonConfigurar = () => (
    <Button type="link" onClick={configurarPlanes}>
      Ir a configuración de planes
    </Button>
  );

  const onchangePlanSelected = ({
    indexPlan,
    tipo,
    planes,
    planesPorTipo,
    idEmpresa,
    moneda
  }) => {
    if (tipo === 'estandar') {
      setSelectedPlanEspecificoIndex(-1);
      setSelectedPlanEstandarIndex(indexPlan);
    } else {
      setSelectedPlanEstandarIndex(-1);
      setSelectedPlanEspecificoIndex(indexPlan);
    }
    planes.map((item) => {
      if (
        item.id ===
        planesPorTipo.filter((planTipo) => planTipo.id_moneda === moneda.id)[
          indexPlan
        ].id
      ) {
        setSelectedPlan({
          planCoberturaItems: item.planSubcobertura,
          id_empresa: idEmpresa
        });
      }
      return item;
    });
  };

  const onDeleteCobertura = (
    id,
    indexProductos,
    indexEmpresa,
    indexCorredora
  ) => {
    const eliminados = [];
    const asignadosCopia = lodashClonedeep(asignados);
    const entryCorredora = Array.from(asignadosCopia.keys())[indexCorredora];
    const modelParam = asignadosCopia.get(entryCorredora).list[indexEmpresa]
      .list[indexProductos];

    const coberturaIndex = modelParam.empresaCoberturaItems.findIndex(
      (item) => item.cobertura.id === id
    );
    const coberturaEliminada = modelParam.empresaCoberturaItems[coberturaIndex];
    if (modelParam.id !== null) {
      eliminados.push(coberturaEliminada);
    }
    asignadosCopia
      .get(entryCorredora)
      .list[indexEmpresa].list[indexProductos].empresaCoberturaItems.splice(
        coberturaIndex,
        1
      );
    setAsignados(asignadosCopia);
    setEmpresaCoberturasItemsEliminadas([
      ...empresaCoberturaItemsEliminadas,
      ...eliminados
    ]);

    return null;
  };

  const addPlan = (coberturaItems, idProducto) => {
    if (!selectedPlan) {
      message.info('Debe seleccionar un plan');
      return;
    }
    // Se modifican los montos de las coberturas existentes y se agregan los no existentes
    selectedPlan.planCoberturaItems.map((plan) => {
      let newCoberturaResumen = null;
      const cobEncontrada = coberturaItems.find((item) => {
        const coberturaResumen = item;
        if (
          coberturaResumen.id_cobertura === plan.subcobertura.cobertura.id &&
          coberturaResumen.id_empresa === selectedPlan.id_empresa
        ) {
          coberturaResumen.monto = plan.monto;
          return true;
        }
        return false;
      });

      if (!cobEncontrada) {
        const moneda = getMoneda(selectedPlan.id_empresa, idProducto);
        newCoberturaResumen = {
          id: null,
          id_empresa: selectedPlan.id_empresa,
          monto: plan.monto,
          orden: plan.orden,
          id_cobertura: plan?.subcobertura?.cobertura.id,
          cobertura: plan?.subcobertura?.cobertura,
          plan: selectedPlan,
          id_moneda: moneda.id,
          id_pais: 1, // TODO: Manejo de paises
          moneda
        };

        coberturaItems.push(newCoberturaResumen);
      }
      return plan;
    });
    setSelectedPlanEstandarIndex(-1);
    setSelectedPlanEspecificoIndex(-1);
    setSelectedPlan();

    const ids = new Set(empresaCoberturaItems.map((d) => d.id));

    const merged = [
      ...empresaCoberturaItems,
      ...coberturaItems.filter((d) => !ids.has(d.id))
    ];

    setEmpresaCoberturasItems(merged);
  };
  const onFinishLanding = async () => {
    try {
      setLoading(true);

      await instanceRef.instance.post(
        `/aseguradoras/${idAseguradora}/landing/coberturas`,
        {
          empresaCoberturaItems,
          empresaCoberturaItemsEliminadas
        }
      );

      setLoading(false);
      message.success('Actualizado correctamente');
      loadAseguradora(idAseguradora);
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const getMoneda = (idEmpresa, idProducto) => {
    // Las monedas modificadas se encuentran guardadas por cada Empresa y Producto en el state monedaProductoList
    if (monedaProductoList.length > 0) {
      const productoEncontrado = monedaProductoList.filter(
        (item) => item.idProducto === idProducto && item.idEmpresa === idEmpresa
      )[0];
      if (productoEncontrado) {
        return productoEncontrado.moneda;
      }
    }
    // Si la moneda no fue modificada, en el Plan Editor se maneja por defecto GS o Moneda Local
    return monedas && monedas.filter((moneda) => moneda.codigo === 'gs')[0];
  };

  const getMonedas = async (items) => {
    const monedasConfiguradas = {};
    items.forEach((item) => {
      monedasConfiguradas[item.moneda.codigo] = item.moneda;
    });
    setMonedas(Object.values(monedasConfiguradas));
  };

  const getPlanesByMoneda = (item) => {
    const moneda = getMoneda(
      item.aseguradoraEmpresa.id_empresa,
      item.producto.id
    );
    if (moneda) {
      const planesList = item.planes.filter(
        (plan) => plan.id_moneda === moneda.id
      );
      return planesList;
    }
    return [];
  };

  const getCoberturasByMoneda = (item) => {
    const moneda = getMoneda(
      item.aseguradoraEmpresa.id_empresa,
      item.producto.id
    );
    if (moneda) {
      const coberturasList = item.empresaCoberturaItems.filter(
        (cobertura) => cobertura.id_moneda === moneda.id
      );
      return coberturasList;
    }
    return [];
  };

  const loadAseguradora = async (id) => {
    setLoading(true);
    try {
      const responseCoberturas = await instanceRef.instance.get(
        `/aseguradoras/${id}/empresacoberturas`
      );
      const response = await instanceRef.instance.get(
        `/aseguradoras/${id}/landing/coberturas`
      );

      setLoading(false);
      if (responseCoberturas.data?.data && response.data?.data) {
        const resumenCoberturas = responseCoberturas.data?.data;
        const aseguradoraEmpresaProductoList = response.data?.data;
        aseguradoraEmpresaProductoList.map((item) => {
          const asegEmpProd = item;
          resumenCoberturas.filter((cob) => {
            if (cob.id === asegEmpProd.aseguradoraEmpresa.id) {
              const productoFilter = cob.empresa.e.filter(
                (e) =>
                  asegEmpProd.id_producto ===
                  e.cobertura.aseguradoraProducto.id_producto
              );
              asegEmpProd.empresaCoberturaItems = productoFilter.map(
                (prod) => ({
                  ...prod,
                  cobertura: {
                    // id: prod.cobertura.id,
                    ...prod.cobertura
                  }
                })
              );
            }

            return null;
          });

          return asegEmpProd;
        });

        const groupedEmpresa = groupBy(
          aseguradoraEmpresaProductoList,
          (item) => item.aseguradoraEmpresa?.empresa?.id || 'empty',
          (item) => item.aseguradoraEmpresa?.empresa
        );

        const groupedCorredora = groupBy(
          groupedEmpresa,
          (item) => item.data?.corredora?.id || 'empty',
          (item) => item.data.corredora
        );

        setAsignados(groupedCorredora);
      }
      if (response.data?.data) {
        getMonedas(response.data.data.flatMap((item) => item.planes));
      }

      setActiveTab({});
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (idAseguradora) {
      loadAseguradora(idAseguradora);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idAseguradora]);

  return (
    <ResponsiveContainer size="large">
      <Card title="Configuración de Landing" style={{ textAlign: 'left' }}>
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div>
            <>
              <Typography.Title level={3}>
                Resumen de Coberturas
              </Typography.Title>
              {asignados &&
                Array.from(asignados.values()).map(
                  (corredora, indexCorredora) => (
                    <Card
                      key={indexCorredora}
                      size="small"
                      style={{ marginBottom: 20 }}
                      title={corredora.data?.nombre || 'Sin Corredora'}
                    >
                      <Collapse expandIconPosition="end">
                        {asignados &&
                          Array.from(corredora.list.values()).map(
                            (value, index) => {
                              return (
                                <Panel
                                  header={<PanelHeader empresa={value.data} />}
                                  key={index}
                                >
                                  <div style={{ overflowX: 'auto' }}>
                                    <Tabs
                                      activeKey={
                                        activeTab[indexCorredora]?.[index]
                                      }
                                      onChange={(tab) =>
                                        onChangeActiveTab(
                                          indexCorredora,
                                          index,
                                          tab
                                        )
                                      }
                                      size="large"
                                    >
                                      {value.list.map(
                                        (item, indexProductos) => {
                                          const planesByMoneda = getPlanesByMoneda(
                                            item
                                          );
                                          const comisionPorDefectoEst = item.cAEP.find(
                                            (com) => com.tipo === 'estandar'
                                          );
                                          const comisionPorDefectoEsp = item.cAEP.find(
                                            (com) => com.tipo === 'especifico'
                                          );
                                          const monedaPlan = getMoneda(
                                            item.aseguradoraEmpresa.id_empresa,
                                            item.producto.id
                                          );
                                          const coberturasByMoneda = getCoberturasByMoneda(
                                            item
                                          );
                                          return (
                                            <TabPane
                                              tab={item.producto.descripcion}
                                              key={indexProductos}
                                            >
                                              <Row gutter={[32, 16]}>
                                                <Col>
                                                  <Space
                                                    style={{ width: '50%' }}
                                                  >
                                                    {planesByMoneda.length >
                                                    0 ? (
                                                      <Button
                                                        type="primary"
                                                        ghost
                                                        icon={
                                                          <SelectOutlined />
                                                        }
                                                        onClick={() => {
                                                          onClickPlanes({
                                                            empresaId:
                                                              value.data.id,
                                                            productoId:
                                                              item.producto.id
                                                          });
                                                        }}
                                                      >
                                                        Planes
                                                      </Button>
                                                    ) : (
                                                      <ButtonConfigurar />
                                                    )}
                                                  </Space>
                                                </Col>
                                                <Col>
                                                  <Space
                                                    style={{
                                                      width: '50%',
                                                      display: 'inline'
                                                    }}
                                                  >
                                                    {monedas &&
                                                      monedas.length > 0 && (
                                                        <MonedaSelector
                                                          value={
                                                            monedaPlan.codigo
                                                          }
                                                          monedas={monedas}
                                                          onChange={(e) => {
                                                            onChangeMoneda(
                                                              e.target.value,
                                                              item
                                                            );
                                                          }}
                                                        />
                                                      )}
                                                  </Space>
                                                </Col>
                                              </Row>
                                              <br />

                                              {mostrarSelector &&
                                                mostrarSelector.estado ===
                                                  true &&
                                                mostrarSelector.empresa ===
                                                  value.data.id &&
                                                mostrarSelector.producto ===
                                                  item.producto.id && (
                                                  <>
                                                    <Space
                                                      direction="vertical"
                                                      align="start"
                                                      style={{
                                                        display: 'grid'
                                                      }}
                                                    >
                                                      <>
                                                        {planesByMoneda.filter(
                                                          (plan) => plan.id_plan
                                                        ).length > 0 ? (
                                                          <div
                                                            style={{
                                                              display: 'grid'
                                                            }}
                                                          >
                                                            <PlanSelector
                                                              key="estandar"
                                                              selected={
                                                                selectedPlanEstandarIndex
                                                              }
                                                              planes={planesByMoneda.filter(
                                                                (plan) =>
                                                                  plan.id_plan &&
                                                                  comisionPorDefectoEst &&
                                                                  plan.id_comision_aseguradora ===
                                                                    comisionPorDefectoEst.id_comision_aseguradora
                                                              )}
                                                              onChange={(
                                                                indexPlan
                                                              ) => {
                                                                onchangePlanSelected(
                                                                  {
                                                                    indexPlan,
                                                                    tipo:
                                                                      'estandar',
                                                                    planes: planesByMoneda,
                                                                    planesPorTipo: planesByMoneda.filter(
                                                                      (plan) =>
                                                                        plan.id_plan &&
                                                                        comisionPorDefectoEst &&
                                                                        plan.id_comision_aseguradora ===
                                                                          comisionPorDefectoEst.id_comision_aseguradora
                                                                    ),
                                                                    idEmpresa:
                                                                      value.data
                                                                        .id,
                                                                    moneda: monedaPlan
                                                                  }
                                                                );
                                                              }}
                                                              hover
                                                              tituloAdicional="Estándar"
                                                              moneda={
                                                                monedaPlan
                                                              }
                                                            />
                                                          </div>
                                                        ) : (
                                                          <p
                                                            style={{
                                                              fontSize: '20px',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            Sin Detalle de
                                                            Cobertura Estándar
                                                          </p>
                                                        )}

                                                        {item.cAEP.length > 0 &&
                                                        planesByMoneda?.filter(
                                                          (plan) =>
                                                            !plan.id_plan
                                                        ).length > 0 ? (
                                                          <div
                                                            style={{
                                                              display: 'grid'
                                                            }}
                                                          >
                                                            <PlanSelector
                                                              key="especifico"
                                                              selected={
                                                                selectedPlanEspecificoIndex
                                                              }
                                                              planes={planesByMoneda.filter(
                                                                (plan) =>
                                                                  !plan.id_plan &&
                                                                  comisionPorDefectoEsp &&
                                                                  plan.id_comision_aseguradora ===
                                                                    comisionPorDefectoEsp.id_comision_aseguradora
                                                              )}
                                                              onChange={(
                                                                indexPlan
                                                              ) => {
                                                                onchangePlanSelected(
                                                                  {
                                                                    indexPlan,
                                                                    tipo:
                                                                      'espcifico',
                                                                    planes: planesByMoneda,
                                                                    planesPorTipo: planesByMoneda.filter(
                                                                      (plan) =>
                                                                        !plan.id_plan &&
                                                                        comisionPorDefectoEsp &&
                                                                        plan.id_comision_aseguradora ===
                                                                          comisionPorDefectoEsp.id_comision_aseguradora
                                                                    ),
                                                                    idEmpresa:
                                                                      value.data
                                                                        .id,
                                                                    moneda: monedaPlan
                                                                  }
                                                                );
                                                              }}
                                                              hover
                                                              tituloAdicional="Específico"
                                                              moneda={
                                                                monedaPlan
                                                              }
                                                            />
                                                          </div>
                                                        ) : (
                                                          <p
                                                            style={{
                                                              fontSize: '20px',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            Sin Detalle de
                                                            Cobertura Específico
                                                          </p>
                                                        )}

                                                        {planesByMoneda.length >
                                                          0 &&
                                                          item.cAEP.length >
                                                            0 && (
                                                            <Button
                                                              type="primary"
                                                              htmlType="submit"
                                                              onClick={() => {
                                                                addPlan(
                                                                  item.empresaCoberturaItems,
                                                                  item.producto
                                                                    .id
                                                                );
                                                              }}
                                                              icon={
                                                                <FileAddOutlined />
                                                              }
                                                            >
                                                              Usar Plan
                                                            </Button>
                                                          )}
                                                      </>
                                                    </Space>
                                                  </>
                                                )}
                                              <br />
                                              {coberturasByMoneda &&
                                              coberturasByMoneda.length > 0 ? (
                                                <>
                                                  <div
                                                    style={{
                                                      display: 'inline-block'
                                                    }}
                                                  >
                                                    <Space
                                                      direction="vertical"
                                                      align="start"
                                                      style={{
                                                        display: 'flex'
                                                      }}
                                                    >
                                                      <PlanEditor
                                                        planes={[]}
                                                        isLanding
                                                        coberturasLanding={
                                                          coberturasByMoneda
                                                        }
                                                        onDeleteCobertura={(
                                                          id
                                                        ) => {
                                                          onDeleteCobertura(
                                                            id,
                                                            indexProductos,
                                                            index,
                                                            indexCorredora
                                                          );
                                                        }}
                                                        moneda={getMoneda(
                                                          value.data.id,
                                                          item.producto.id
                                                        )}
                                                      />
                                                    </Space>
                                                  </div>
                                                </>
                                              ) : (
                                                <p
                                                  style={{
                                                    fontSize: '20px',
                                                    fontWeight: 'bold'
                                                  }}
                                                >
                                                  Sin Resumen de Coberturas
                                                </p>
                                              )}
                                            </TabPane>
                                          );
                                        }
                                      )}
                                    </Tabs>
                                  </div>
                                </Panel>
                              );
                            }
                          )}
                      </Collapse>
                    </Card>
                  )
                )}
            </>
            <br />
            <Button
              type="primary"
              htmlType="submit"
              onClick={onFinishLanding}
              icon={<SaveOutlined />}
            >
              Actualizar
            </Button>
          </div>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
};

export default AdminAseguradoraLanding;
